// @flow
import oldContractProductsFetcher from './old-contract';
// $FlowFixMe
import newContractProductsFetcher from './new-contract';

export default (
  cid: number,
  departmentId: string,
  facetQueryString: string,
  pageNumber: number,
  productsUrl: string,
  productsApiKey: string,
  hideDepartmentFacet: boolean,
  hidePriceFacet: boolean,
  abSeg: {
    pgAT: string,
    pgBR: string,
    pgGP: string,
    pgON: string,
    pgGPFS: string,
    pgBRFS: string,
    pgATCA: string,
    pgBRCA: string,
    pgGPCA: string,
    pgONCA: string,
  },
  previewState: {},
  isFlexFacetsEnabled: boolean,
  locale: Locale,
  ignoreInventory: boolean,
  isRatingsFacetEnabled: boolean,
  isDynamicStyleFacetNameEnabled: boolean,
  webHierarchy: [],
  selectedNodes: [],
  isNewContractEnabled: boolean,
  commerceProductsSearchUrl: string,
  brand: string,
  market: string
) => {
  if (isNewContractEnabled) {
    const parameters = {
      ...previewState,
      facetQueryString,
      brand,
      cid,
      locale,
      market,
      pageNumber,
    };
    return newContractProductsFetcher(commerceProductsSearchUrl, parameters);
  } else {
    return oldContractProductsFetcher(
      cid,
      departmentId,
      facetQueryString,
      pageNumber,
      productsUrl,
      productsApiKey,
      hideDepartmentFacet,
      hidePriceFacet,
      abSeg,
      previewState,
      isFlexFacetsEnabled,
      locale,
      ignoreInventory,
      isRatingsFacetEnabled,
      isDynamicStyleFacetNameEnabled,
      webHierarchy,
      selectedNodes
    );
  }
};
